/**
 * v-debounce
 * 按钮防抖指令，可自行扩展至input
 * 接收参数：function类型
 */
import type { Directive, DirectiveBinding } from "vue";
import { debounce as _debounce } from "lodash-es";

interface ElType extends HTMLElement {
    __handleClick__?: (event: MouseEvent) => any;
    __debouncedFn__?: (...args: any[]) => void;
}
const debounce: Directive = {
    mounted(el: ElType, binding: DirectiveBinding) {
        if (typeof binding.value !== "function") {
            throw "v-debounce: binding.value must be a function";
        }
        // 初始化防抖函数
        const createDebouncedFn = () => {
            return _debounce((...args) => {
                binding.value(...args);
            }, 500);
        };

        el.__debouncedFn__ = createDebouncedFn();
        el.__handleClick__ = (event: MouseEvent) => {
            // 先判断是否需要阻止事件冒泡，如果指令绑定有.stop修饰符
            if (binding.modifiers && binding.modifiers.stop) {
                event.stopPropagation();
            }
            el.__debouncedFn__!(event);
        };

        // 添加点击事件监听
        el.addEventListener("click", el.__handleClick__);
    },
    updated(el: ElType, binding: DirectiveBinding) {
        // 数据变化时重新生成防抖函数
        el.__debouncedFn__ = _debounce((...args) => {
            binding.value(...args);
        }, 500);
    },
    beforeUnmount(el: ElType) {
        // 清理事件监听器
        if (el.__handleClick__) {
            el.removeEventListener("click", el.__handleClick__);
        }
        el.__handleClick__ = undefined;
        el.__debouncedFn__ = undefined;
    }
};

export default debounce;
